import { useMutation, useQueryClient } from '@tanstack/react-query';

import { eventsAccessClient } from './client';
import { EVENTS_ACCESS_QUERY_KEYS } from './queries';

/**
 * No optimistic update: the backend decides whether the affected session is refreshed eagerly or
 * at its next resolve, so the truthful thing to show is the server's answer once it lands.
 */
const useEventsAccessMutation = <TVariables>(
  mutationFn: (_variables: TVariables) => Promise<void>,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [EVENTS_ACCESS_QUERY_KEYS.eventsAccess] }),
  });
};

export const useSetPersonEventsAccess = () =>
  useEventsAccessMutation(({ userId, granted }: { userId: string; granted: boolean }) =>
    eventsAccessClient.setPersonAccess(userId, granted),
  );
